module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("fwyzT"))).then(() => parcelRequire('ikE14'));